<div class="boxWhite">
    <h4>DESHACER INICIO JORNADA</h4>

    <button class="btn btnClose" (click)="close()">
        <img src="assets/img/icoClose.svg" alt="">
    </button>

    <div class="contModal">
        <div class="row">
            <div class="col-sm-6">
                <h6 class="clBlack">ID CB</h6>
                <p class="clGray mb-4">{{jornada?.conductor.visibleId}}</p>
            </div>
            <div class="col-sm-6">
                <h6 class="clBlack">nombre conductor</h6>
                <p class="clGray mb-4">{{jornada?.conductor.nombres}} {{jornada?.conductor.apellidoPaterno}}</p>
            </div>
        </div>

        <div class="row">
            <div class="col-sm-6">
                <h6 class="clBlack">HORA</h6>
                <p class="clGray mb-4">{{muestraHora(jornada?.fechaInicioPlanificado)}}</p>
            </div>
            <div class="col-sm-6">
              <h6 class="clBlack">sucursal origen</h6>
              <p class="clGray mb-4 textoRojo">{{jornada?.sucursal.nombre}}</p>
            </div>
        </div>



        <div class="row">
            <div class="col-sm-12">
                <!--<div class="boxInsideModal bgGreen mb-4 d-flex align-items-center justify-content-between">
                    <div class="d-flex flex-column justify-content-center">
                        <h6>Estado</h6>
                        <p class="clWhite m-0 fw-medium">JORNADA INICIADA</p>
                    </div>
                    <button class="btn">
                        <div class="bigIcon bgBlack">
                            <img src="assets/img/icoPrint.svg" alt="">
                        </div>
                    </button>
                </div>-->
              <textarea placeholder="MOTIVO" rows="4" class="form-control mb-4 textareaMotivo" maxlength="500" [(ngModel)]="comentario"></textarea>
            </div>
        </div>

    </div>


    <div class="footModal">
        <button *ngIf="tienePermisoCancelarJornada()" class="btn btnRed w-100" [disabled]="enviando" (click)="putCancelarJornada()">
            <span *ngIf="enviando" class="spinner-border spinner-border-sm me-2" role="status" aria-hidden="true"></span>
            DESHACER I. JORNADA
        </button>
    </div>


</div>
